import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Fleetguard filed our FMCSA paperwork before the ink dried. Three trucks insured the same afternoon — and the discount on our first term was very real.",
    name: "Marcus Delgado",
    fleet: "Delgado Hauling LLC · Laredo, TX",
    trucks: "6 trucks",
    saved: "Saved $3,900/yr",
  },
  {
    quote:
      "Our last broker took weeks to answer a claim. Fleetguard picks up on the first ring. Switching nine trucks over was the easiest decision we've made.",
    name: "Sarah Whitmore",
    fleet: "Whitmore Freight Co. · Columbus, OH",
    trucks: "9 trucks",
    saved: "Saved $8,400/yr",
  },
  {
    quote:
      "They beat my previous invoice by nearly half and walked me through every line of the agreement. Honest, fast, professional.",
    name: "James Okafor",
    fleet: "Okafor Logistics · Atlanta, GA",
    trucks: "14 trucks",
    saved: "Saved $6,100/yr",
  },
];

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="bg-brand-paper py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="text-center">
          <p className="eyebrow">Testimonials</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-brand-navy sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
            Fleets that switched, and stayed.
          </h2>
        </div>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-3" data-testid="testimonials-grid">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.08 * i} className="h-full">
            <figure
              className="flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-900/5"
              data-testid={`testimonial-card-${i}`}
            >
              <div className="flex gap-1">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-slate-700">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center justify-between gap-3 border-t border-slate-100 pt-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-ice font-display text-sm font-bold text-brand-blue">
                    {t.name.split(" ").map((n) => n[0]).join("")}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-brand-navy">{t.name}</p>
                    <p className="text-xs text-slate-500">{t.fleet}</p>
                  </div>
                </div>
              </figcaption>
              <div className="mt-4 flex gap-2">
                <span className="rounded-full bg-slate-100 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-slate-500">
                  {t.trucks}
                </span>
                <span className="rounded-full bg-orange-50 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-widest text-brand-orange">
                  {t.saved}
                </span>
              </div>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
